import * as Yup from 'yup';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { TEXT_TO_SPEECH_MAX_NAME_LENGTH } from '../../utils';

interface Props {
  initialName: string;
}

export const useRenameForm = ({ initialName }: Props) => {
  const FormSchema = Yup.object().shape({
    name: Yup.string()
      .required('Name is required')
      .max(
        TEXT_TO_SPEECH_MAX_NAME_LENGTH,
        `Name must be at most ${TEXT_TO_SPEECH_MAX_NAME_LENGTH} characters`
      )
      .typeError('Name must be a valid string'),
  });

  const formMethods = useForm({
    resolver: yupResolver(FormSchema),
    defaultValues: { name: initialName || '' },
    mode: 'onChange',
  });

  return formMethods;
};
